import { TenantSiteConfig } from '../../models/wholesaler-api-models';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SiteConfigService {
  constructor(private http: HttpClient) {}

  /**
   * Get the site style items from the API
   */
  async getSiteConfig(): Promise<TenantSiteConfig> {
    try {
      return await firstValueFrom(this.http.get<TenantSiteConfig>('TenantConfig/site'));
    } catch (error) {
      throw new Error('Failed to load site config');
    }
  }
}
